import * as $ from 'jquery'

import './styles/styles.css'
